module.exports = __webpack_public_path__ + "img/bg39.784921d0.png";